import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-gray-200">
      <button
        onClick={() => setOpen(!open)}
        className={`w-full text-left flex justify-between items-center py-4 px-2 ${open ? 'text-orange-600 font-semibold' : 'text-gray-800 hover:text-orange-500'}`}
        aria-expanded={open}
      >
        <span className="truncate">{q}</span>
        <span className="text-gray-500 ml-4 text-xl">{open ? '-' : '+'}</span>
      </button>

      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ maxHeight: open ? '500px' : '0px' }}
        aria-hidden={!open}
      >
        <div className="pt-2 pb-6 px-2 text-gray-600 leading-relaxed">
          {a}
        </div>
      </div>
    </div>
  );
}

function Faq() {
  return (
    <div className="bg-white min-h-screen">
      <Header />

      <PageBanner
        title="Frequently Asked Questions"
        subtitle="Find answers to common questions about MyTrip4U and our services."
        image="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1920&q=80"
      />

      <main className="max-w-7xl mx-auto px-6 py-20">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <FAQItem
            q="How do you determine 'nearby' locations?"
            a="We use your device's geolocation (when permitted) to calculate distance to listings and rank them accordingly. If geolocation is not available, we use your IP address to estimate your location."
          />
          <FAQItem
            q="Can I request a partnership or add my business?"
            a="Yes — use the contact form and include details about your property or service. We'll review your request and reply within 48 hours."
          />
          <FAQItem
            q="How accurate are the distances shown?"
            a="Distances are calculated using the Haversine formula and shown in kilometers. While we strive for accuracy, actual travel distances may vary due to road conditions and routing."
          />
          <FAQItem
            q="Is my personal information safe?"
            a="Yes, we take privacy seriously. We only collect information necessary for providing our services and comply with data protection regulations. See our Privacy Policy for more details."
          />
          <FAQItem
            q="How do I contact customer support?"
            a="You can reach us through the contact form on our website, or email us directly. We aim to respond to all inquiries within 24 hours."
          />
          <FAQItem
            q="Are the listings verified?"
            a="We source our data from reliable providers and regularly update our listings. However, we recommend contacting establishments directly to confirm current information."
          />
          <FAQItem
            q="Can I use MyTrip4U on mobile devices?"
            a="Absolutely! Our website is fully responsive and works seamlessly on all devices including smartphones and tablets."
          />
          <FAQItem
            q="How often is the data updated?"
            a="We update our listings regularly to ensure you have access to the most current information about hotels and restaurants in your area."
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Faq;